import { NavigationConfig } from './navigation_config';
var PERMISSION_ROUTE_MAP = {
    'USER_MANAGMENT': [
        NavigationConfig.UserManagement,
    ],
    'APPLICATION_MANAGMENT': [
        NavigationConfig.BacklogManagement,
        NavigationConfig.BacklogAppDetails,
        NavigationConfig.ApplicationManagement,
        NavigationConfig.ApplicationDetails,
        NavigationConfig.CreateApplication,
    ],
    'MARKETING_CONTENT': [
        NavigationConfig.MarketingConent,
    ],
    'ADMINISTRATOR:ADMIN_MGMT:USERS': [
        NavigationConfig.AdminManagement,
    ],
    'ADMINISTRATOR:ADMIN_MGMT:ROLES_PERMISSIONS': [
        NavigationConfig.RolesPermissions,
    ],
    'ADMINISTRATOR:ADMIN_MGMT': [
        NavigationConfig.AdminManagement,
    ],
    'ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT': [
        NavigationConfig.DealerManagement,
    ],
    'ADMINISTRATOR:PORTAL_SETUP:DEALER_PROGRAM_ASSOCIATION': [
        NavigationConfig.DealerProgramAssocation,
    ],
    'ADMINISTRATOR:PORTAL_SETUP:PROGRAM_MGMT': [
        NavigationConfig.ProgramManagement,
    ],
    'ADMINISTRATOR:PORTAL_SETUP': [
        NavigationConfig.DealerManagement,
    ],
    'ADMINISTRATOR:GLOBAL_SETTINGS:INSURANCE_POLICY': [
        NavigationConfig.InsuranceConfig,
    ],
    'ADMINISTRATOR:GLOBAL_SETTINGS:CHATBOT_FAQS': [
        NavigationConfig.ChatbotConfig,
    ],
    'ADMINISTRATOR:GLOBAL_SETTINGS': [
        NavigationConfig.InsuranceConfig,
    ],
    'ADMINISTRATOR:RESUBMIT_APPLICATION': [
        NavigationConfig.ResubmitApplication,
    ],
    'CUSTOMER_PORTAL': [
        NavigationConfig.CustomerPortalDashboard,
        NavigationConfig.CustomerPortalUserManagement,
        NavigationConfig.PaymentManagement,
        NavigationConfig.DocumentManagement,
        NavigationConfig.DocumentTypeAccess,
        NavigationConfig.DocumentSize,
        NavigationConfig.CustomerPortalSupportManagement,
        NavigationConfig.BrandCustomization,
    ],
};
var PERMISSION_PRIORITY = [
    'USER_MANAGMENT',
    'APPLICATION_MANAGMENT',
    'MARKETING_CONTENT',
    'ADMINISTRATOR:ADMIN_MGMT:USERS',
    'ADMINISTRATOR:ADMIN_MGMT:ROLES_PERMISSIONS',
    'ADMINISTRATOR:ADMIN_MGMT',
    'ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT',
    'ADMINISTRATOR:PORTAL_SETUP:DEALER_PROGRAM_ASSOCIATION',
    'ADMINISTRATOR:PORTAL_SETUP:PROGRAM_MGMT',
    'ADMINISTRATOR:PORTAL_SETUP',
    'ADMINISTRATOR:GLOBAL_SETTINGS:INSURANCE_POLICY',
    'ADMINISTRATOR:GLOBAL_SETTINGS:CHATBOT_FAQS',
    'ADMINISTRATOR:GLOBAL_SETTINGS',
    'ADMINISTRATOR:RESUBMIT_APPLICATION',
    'CUSTOMER_PORTAL',
];
export var getDefaultLandingRoute = function (rolePermissions) {
    if (!rolePermissions || rolePermissions.length === 0) {
        return NavigationConfig.Account.Login;
    }
    for (var _i = 0, PERMISSION_PRIORITY_1 = PERMISSION_PRIORITY; _i < PERMISSION_PRIORITY_1.length; _i++) {
        var permissionKey = PERMISSION_PRIORITY_1[_i];
        if (hasViewPermission(rolePermissions, permissionKey)) {
            var routes = PERMISSION_ROUTE_MAP[permissionKey];
            if (routes && routes.length > 0) {
                return routes[0];
            }
        }
    }
    return '/dashboard';
};
export var hasViewPermission = function (rolePermissions, permissionKey) {
    var isAnyActionEnabled = function (perm) {
        return Number(perm.View) === 1 ||
            Number(perm.Add) === 1 ||
            Number(perm.Update) === 1 ||
            Number(perm.Delete) === 1;
    };
    var exactMatch = rolePermissions.find(function (perm) { return perm.PermissionKey === permissionKey; });
    if (exactMatch && isAnyActionEnabled(exactMatch))
        return true;
    var hasChildAction = rolePermissions.some(function (perm) { return perm.PermissionKey.startsWith("".concat(permissionKey, ":")) && isAnyActionEnabled(perm); });
    return hasChildAction;
};
export var getAccessibleRoutes = function (rolePermissions) {
    if (!rolePermissions || rolePermissions.length === 0) {
        return [];
    }
    var routes = [];
    var mappedPermissionKeys = Object.keys(PERMISSION_ROUTE_MAP);
    mappedPermissionKeys.forEach(function (key) {
        if (hasViewPermission(rolePermissions, key)) {
            var permissionRoutes = PERMISSION_ROUTE_MAP[key];
            if (permissionRoutes) {
                routes.push.apply(routes, permissionRoutes);
            }
        }
    });
    return Array.from(new Set(routes));
};
